module.exports = __webpack_public_path__ + "static/img/image_faq_detail@3x.a8f5228.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/image_faq_detail@3x.png
// module id = 111
// module chunks = 18